import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@design-system';
import { EditAssumptionsContent } from './edit-assumptions-content';

interface EditAssumptionsDialogProps {
  children: React.ReactNode;
}

export function EditAssumptionsDialog({ children }: EditAssumptionsDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="grid max-h-[95dvh] w-full grid-rows-[auto,1fr] gap-3 overflow-scroll rounded-2xl px-0 pb-0 pt-3 sm:max-w-4xl md:gap-4 md:rounded-3xl md:pt-6">
        <DialogHeader className="px-4 text-start md:px-8">
          <DialogTitle className="text-primary-dark text-lg md:text-2xl">
            Edit Assumptions
          </DialogTitle>
          <p className="text-foreground text-sm">Customize your care cost projections</p>
        </DialogHeader>
        <div className="overflow-y-auto px-4 pb-6 md:px-8">
          <EditAssumptionsContent />
        </div>
      </DialogContent>
    </Dialog>
  );
}
